import { useReactiveVar } from "@apollo/client";
import React, { useEffect, useMemo } from "react";
import { Col, Dropdown, Row, Spinner } from "react-bootstrap";
import { Check2, ChevronDown } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { usePaymentPlansQuery } from "../../graphql/payment.hooks";
import { isPaymentError, selectedCurrency } from "../../graphql/state";
import Invoice from "./invoice";
import PremiumPlans from "./premiumPlans";
import Subscription from "./subscription";
import { TrialToast } from "../../components/toast/trialToast/TrialToast";

export default function Payment() {
  const { t } = useTranslation();
  const currentCurrency = useReactiveVar(selectedCurrency);
  const {
    data: paymentPlanData,
    loading: paymentPlanLoading,
    error,
  } = usePaymentPlansQuery({
    variables: { locale: "en", currency: "usd" },
  });

  const currentPlan = useMemo(
    () =>
      paymentPlanData?.paymentPlans?.plans.find(
        (item) => item.planName === paymentPlanData?.paymentPlans?.type
      ),
    [paymentPlanData?.paymentPlans]
  );

  useEffect(() => {
    document.title = "Payment";
  }, []);

  useEffect(() => {
    if (!error) return;
    isPaymentError(true);
  }, [error]);

  return (
    <div className="text-dark">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 className="fs-1 fw-bold">{t("menu.paymentSubscription")}</h1>
        </div>
        {paymentPlanLoading ? (
          <Spinner animation="border" role="status" />
        ) : (
          <Dropdown>
            <Dropdown.Toggle className="border-0 round bg-white fs-5 text-dark ps-3 fw-normal text-uppercase">
              {currentCurrency}
              <ChevronDown className="ms-4" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="currency-scroll-menu">
              {paymentPlanData?.paymentPlans.currencies.map(
                ({ currencyName }) => (
                  <Dropdown.Item
                    key={currencyName}
                    onClick={() => selectedCurrency(currencyName)}
                    className={`text-uppercase text-center d-flex align-items-center ${currentCurrency === currencyName && "bg-additional-gray"}`}
                  >
                    <Check2
                      className={`fs-5 me-2 ${currentCurrency === currencyName ? "text-primary" : "text-transparent"}`}
                    />
                    <p className="m-0 text-dark">{currencyName}</p>
                  </Dropdown.Item>
                )
              )}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
      <TrialToast checkoutUrl={currentPlan?.checkoutUrl} />
      <Row className="g-4">
        <Col lg={5}>
          <Subscription />
        </Col>
        <Col lg={7}>
          <Row className="g-4">
            <Col sm={12}>
              <PremiumPlans />
            </Col>
            <Col sm={12}>
              <Invoice />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
